import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FileUpload } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useFileUpload } from './useFileUpload';
import './docTypeFileInput.scss';
import { VALIDATION_ERROR_MESSAGE } from '../../../constants/errorMessage';

const DocTypeFileInput = ({ formKey, selectedFiles, isRequired, requiredMessage, isUploading, onUploadingChange }) => {
  const { files, handleRemoveFile, handleFileChange, formContext } = useFileUpload({
    incomingFiles: selectedFiles,
    formKey
  });
  useEffect(() => {
    if (onUploadingChange) {
      onUploadingChange(formKey, isUploading);
    }

    return () => {
      if (onUploadingChange) {
        onUploadingChange(formKey, false);
      }
    };
  }, [isUploading, formKey, onUploadingChange]);

  const allFiles = [...files].filter(Boolean);

  const fileValidation = {
    required: isRequired
      ? { value: true, message: requiredMessage || 'Please upload at least one item or add a comment below.' }
      : { value: false, message: '' },
    maxFileCountLimit: VALIDATION_ERROR_MESSAGE.MAX_FILE_COUNT,
    unsupportedFileType: VALIDATION_ERROR_MESSAGE.UNSUPPORTED_FILE_TYPE
  };
  return (
    <fieldset className="fileUploadFieldset">
      <FileUpload
        key={
          allFiles && allFiles.length > 0
            ? allFiles
                .filter(Boolean)
                .map((file) => file.documentId || `${file.name}-${file.size}-${file.lastModified}`)
                .join(',')
            : formKey
        }
        showSpinner={isUploading}
        name={formKey}
        inputType="file"
        label="Select file/s"
        labelStyle="button"
        listStyle="reveal"
        customCssClass={formContext.formState.errors[formKey] ? 'fileUploadCustomError' : ''}
        fieldFormContext={formContext}
        validation={fileValidation}
        placeholder="Itemised invoice/s"
        validFiles={{
          extensions: [
            'application/pdf',
            'image/apng',
            'image/gif',
            'image/jpeg',
            'image/pjpeg',
            'image/png',
            'image/tiff',
            'image/webp'
          ],
          fileTypes: 'documents',
          supportsLabel: 'pdfs, png, apng, jpeg, pjpeg, png, tiff, webp',
          maxFileSize: 10485760, // 10 MB
          maxFileCount: 8
        }}
        defaultSelectedFiles={allFiles}
        customRemoveHandler={handleRemoveFile}
        customChangeHandler={handleFileChange}
      />
    </fieldset>
  );
};

export default DocTypeFileInput;

const DocTypeFileInputPropTypes = {
  formKey: PropTypes.string.isRequired,
  selectedFiles: PropTypes.arrayOf(
    PropTypes.shape({
      DocumentId: PropTypes.string.isRequired,
      FileName: PropTypes.string.isRequired,
      FileType: PropTypes.string.isRequired
    })
  ),
  isRequired: PropTypes.bool,
  requiredMessage: PropTypes.string,
  isUploading: PropTypes.bool,
  onUploadingChange: PropTypes.func
};

DocTypeFileInput.propTypes = DocTypeFileInputPropTypes;
